import React from 'react'
import badge from "../../assets/svgs/badge.svg"

const Badges = () => {
  return (
    <div className='w-[80%] bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] mx-auto rounded-2xl px-5'>
        <p className='mt-4 font-light text-lg text-main-blue'>My badges</p>
        <div className = "flex justify-center">
          <img src = {badge} alt = "badge"/>
        </div>
    </div>
  )
}

export default Badges